export const AppGQLCacheConfig: string[] = [
    'listarColumnaDatatableByDatatable',
    'allMaestroDominiosByDominio'
];
